(() => {
  const root = document.querySelector('.tb');
  if (!root) return;
  const media = matchMedia('(prefers-reduced-motion: reduce)');
  const targets = [...root.querySelectorAll('.tb-reveal, .tb-progress')];
  const cleanup = () => targets.forEach(el => {
    el.classList.remove('tb-motion-ready');
    el.classList.add('tb-visible');
  });
  if (media.matches || !('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('tb-visible');
      observer.unobserve(entry.target);
    });
  }, {threshold: 0.12});
  try {
    targets.forEach(el => observer.observe(el));
    targets.forEach(el => el.classList.add('tb-motion-ready'));
  } catch {
    observer.disconnect();
    cleanup();
  }
  const update = () => {
    if (media.matches) {
      observer.disconnect();
      cleanup();
    }
  };
  media.addEventListener('change', update);
})();
